/* =====================================================
   UNITED CHEM — QUOTE CART (site-wide)
   Stores requested materials in localStorage and sends
   the request to WhatsApp. Loaded on every page from
   layout/theme.liquid; config comes from window.UCConfig.
===================================================== */
(function () {
  if (window.UCQuoteCart) return;

  var KEY = 'unitedchem_quote_cart';
  var LEGACY_KEY = 'uc_pending_quote_item';
  var LAST_KEY = 'unitedchem_last_quote';
  var config = window.UCConfig || {};

  function storageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }
  function storageRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  function read() {
    try {
      var items = JSON.parse(storageGet(KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function emit(items) {
    window.dispatchEvent(new CustomEvent('uc:quote-cart-updated', { detail: items }));
  }

  function write(items) {
    storageSet(KEY, JSON.stringify(items));
    emit(items);
    return items;
  }

  function normalize(item) {
    var options = item.quantity_options;
    if (options && !Array.isArray(options) && Array.isArray(options.value)) options = options.value;
    return {
      id: String(item.id || item.handle || ''),
      handle: item.handle || '',
      title: item.title || '',
      image: item.image || '',
      url: item.url || (item.handle ? '/products/' + item.handle : ''),
      quantity: item.quantity || '',
      chemical_name: item.chemical_name || '',
      minimum_order: item.minimum_order || '',
      quantity_options: Array.isArray(options) ? options : []
    };
  }

  /* Older product pages saved a single item under a different key — merge it in. */
  (function migrateLegacy() {
    var legacy = storageGet(LEGACY_KEY);
    if (!legacy) return;
    storageRemove(LEGACY_KEY);
    try {
      var item = normalize(JSON.parse(legacy));
      if (!item.id) return;
      var items = read();
      if (!items.some(function (i) { return String(i.id) === item.id; })) items.push(item);
      storageSet(KEY, JSON.stringify(items));
    } catch (e) {}
  })();

  function add(raw, opts) {
    var item = normalize(raw);
    if (!item.id) return read();
    var items = read();
    var found = null;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === item.id) { found = items[i]; break; }
    }
    if (found) {
      if (item.quantity) found.quantity = item.quantity;
      if (item.quantity_options.length) found.quantity_options = item.quantity_options;
      if (item.chemical_name) found.chemical_name = item.chemical_name;
    } else {
      items.push(item);
    }
    write(items);
    if (!opts || opts.toast !== false) showToast(item, items.length);
    return items;
  }

  function update(id, patch) {
    var items = read();
    items.forEach(function (item) {
      if (String(item.id) === String(id)) Object.assign(item, patch);
    });
    return write(items);
  }

  function remove(id) {
    return write(read().filter(function (item) { return String(item.id) !== String(id); }));
  }

  function clear() {
    return write([]);
  }

  function absoluteUrl(url) {
    if (!url) return '';
    if (/^https?:/i.test(url)) return url;
    return (window.shopUrl || window.location.origin) + url;
  }

  function reference() {
    var d = new Date();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    return 'UC-' + String(d.getFullYear()).slice(2) + pad(d.getMonth() + 1) + pad(d.getDate()) +
      '-' + Math.floor(1000 + Math.random() * 9000);
  }

  function buildMessage(details, items, ref) {
    details = details || {};
    items = items || read();
    var lines = [config.greeting || 'مرحبًا UNITED CHEM 👋 أريد عرض سعر للخامات التالية:', ''];
    items.forEach(function (item, index) {
      lines.push((index + 1) + ') ' + item.title);
      lines.push('   الكمية: ' + (item.quantity || item.minimum_order || 'تُحدد لاحقًا'));
      if (item.url) lines.push('   ' + absoluteUrl(item.url));
    });
    lines.push('');
    if (details.name) lines.push('👤 الاسم: ' + details.name);
    if (details.company) lines.push('🏢 الشركة: ' + details.company);
    if (details.phone) lines.push('📞 الموبايل: ' + details.phone);
    if (details.city) lines.push('📍 المحافظة / المدينة: ' + details.city);
    if (details.notes) lines.push('📝 ملاحظات: ' + details.notes);
    if (ref) lines.push('🔖 رقم الطلب: ' + ref);
    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  function whatsappUrl(text) {
    var number = String(config.whatsapp || '').replace(/\D/g, '');
    return 'https://wa.me/' + number + (text ? '?text=' + encodeURIComponent(text) : '');
  }

  function openWhatsApp(url) {
    var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      window.location.href = url;
    } else {
      var win = window.open(url, '_blank', 'noopener');
      if (!win) window.location.href = url;
    }
  }

  /* Sends the whole cart to WhatsApp. Keeps a copy so the customer can re-send. */
  function send(details) {
    var items = read();
    if (!items.length) return null;
    var ref = reference();
    var text = buildMessage(details, items, ref);
    var url = whatsappUrl(text);
    storageSet(LAST_KEY, JSON.stringify({ ref: ref, url: url, items: items, at: Date.now() }));
    openWhatsApp(url);
    clear();
    return { ref: ref, url: url, items: items };
  }

  function lastQuote() {
    try { return JSON.parse(storageGet(LAST_KEY) || 'null'); } catch (e) { return null; }
  }

  /* -------------------- UI: counters -------------------- */
  function refreshCounters() {
    var count = read().length;
    document.querySelectorAll('[data-uc-quote-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
    });
    document.documentElement.classList.toggle('uc-has-quote', count > 0);
  }

  /* -------------------- UI: toast -------------------- */
  var toastTimer;
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c];
    });
  }

  function showToast(item, count) {
    var toast = document.getElementById('uc-quote-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'uc-quote-toast';
      toast.className = 'uc-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('dir', 'rtl');
      document.body.appendChild(toast);
    }
    toast.innerHTML =
      '<div class="uc-toast__row">' +
        (item.image ? '<img class="uc-toast__img" src="' + esc(item.image) + '" alt="">' : '<span class="uc-toast__check">✓</span>') +
        '<div class="uc-toast__text"><strong>تمت الإضافة لطلب السعر ✓</strong>' +
        '<span>' + esc(item.title) + (item.quantity ? ' — ' + esc(item.quantity) : '') + '</span></div>' +
        '<button type="button" class="uc-toast__close" aria-label="إغلاق" data-uc-toast-close>×</button>' +
      '</div>' +
      '<div class="uc-toast__actions">' +
        '<button type="button" class="uc-toast__btn uc-toast__btn--ghost" data-uc-toast-close>متابعة التصفح</button>' +
        '<a class="uc-toast__btn uc-toast__btn--primary" href="' + esc(config.quoteUrl || '/pages/quote-request') + '">' +
          'عرض الطلب وإرساله (' + count + ')</a>' +
      '</div>';
    void toast.offsetWidth; // flush styles so the slide-in transition runs
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }

  function hideToast() {
    var toast = document.getElementById('uc-quote-toast');
    if (toast) toast.classList.remove('is-open');
  }

  /* -------------------- UI: delegated clicks -------------------- */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-uc-toast-close]')) {
      hideToast();
      return;
    }

    /* Quick "+ طلب سعر" buttons on product cards */
    var quick = event.target.closest('[data-uc-quick-quote]');
    if (quick) {
      event.preventDefault();
      event.stopPropagation();
      try {
        add(JSON.parse(quick.getAttribute('data-product') || '{}'));
        quick.classList.add('is-added');
        setTimeout(function () { quick.classList.remove('is-added'); }, 2000);
      } catch (e) {}
    }
  }, true);

  window.addEventListener('uc:quote-cart-updated', refreshCounters);
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) refreshCounters();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCounters);
  } else {
    refreshCounters();
  }

  window.UCQuoteCart = {
    read: read,
    add: add,
    update: update,
    remove: remove,
    clear: clear,
    count: function () { return read().length; },
    buildMessage: buildMessage,
    whatsappUrl: whatsappUrl,
    send: send,
    lastQuote: lastQuote,
    showToast: showToast
  };
})();
